import isEmpty from 'lodash/isEmpty';
import { useRef } from 'react';

import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';
function SectionThree({ dataSet, handleRefExclusive }: any) {
  const allData = {
    item1: convertDatasets(dataSet, 'icon', true),
    item2: convertDatasets(dataSet, 'Exclusive', true),
    item3: convertDatasets(dataSet, 'Expert', true),
    item4: convertDatasets(dataSet, 'Experience', true),
    item5: convertDatasets(dataSet, 'image-b3-1', true),
    item6: convertDatasets(dataSet, 'image-b3-2', true),
    item7: convertDatasets(dataSet, 'image-b3-3', true),
    item8: convertDatasets(dataSet, 'image-b3-4', true),
    item9: convertDatasets(dataSet, 'image-b3-5', true),
    item10: convertDatasets(dataSet, 'image-b3-6', true),
    item11: convertDatasets(dataSet, 'image-b3-7', true),
    item12: convertDatasets(dataSet, 'image-b4-1', true),
    item13: convertDatasets(dataSet, 'image-b4-2', true),
    item14: convertDatasets(dataSet, 'image-b4-3', true),
    item15: convertDatasets(dataSet, 'image-b4-4', true),
    item16: convertDatasets(dataSet, 'agenda-title-1', true),
    item17: convertDatasets(dataSet, 'agenda-title-2', true),
    item18: convertDatasets(dataSet, 'time-1', true),
    item19: convertDatasets(dataSet, 'time-2', true),
    item20: convertDatasets(dataSet, 'time-3', true),
    item21: convertDatasets(dataSet, 'time-4', true),
    item22: convertDatasets(dataSet, 'time-5', true),
    item23: convertDatasets(dataSet, 'time-6', true),
    item24: convertDatasets(dataSet, 'desc-1', true),
    item25: convertDatasets(dataSet, 'desc-2', true),
    item26: convertDatasets(dataSet, 'desc-3', true),
    item27: convertDatasets(dataSet, 'desc-4', true),
    item28: convertDatasets(dataSet, 'desc-5', true),
    item29: convertDatasets(dataSet, 'desc-6', true),
    item30: convertDatasets(dataSet, 'title-block2', true),
    item31: convertDatasets(dataSet, 'subtitle-1', true),
    item32: convertDatasets(dataSet, 'subtitle-2', true),
    item33: convertDatasets(dataSet, 'subtitle-3', true),
    item34: convertDatasets(dataSet, 'header-block3-1', true),
    item35: convertDatasets(dataSet, 'title-b3-1', true),
    item36: convertDatasets(dataSet, 'name-b3-1', true),
    item37: convertDatasets(dataSet, 'position-b3-1', true),
    item38: convertDatasets(dataSet, 'title-b3-2', true),
    item39: convertDatasets(dataSet, 'name-b3-2', true),
    item40: convertDatasets(dataSet, 'position-b3-2', true),
    item41: convertDatasets(dataSet, 'header-block3-2', true),
    item42: convertDatasets(dataSet, 'name-b3-3', true),
    item43: convertDatasets(dataSet, 'position-b3-3', true),
    item44: convertDatasets(dataSet, 'name-b3-4', true),
    item45: convertDatasets(dataSet, 'position-b3-4', true),
    item46: convertDatasets(dataSet, 'name-b3-5', true),
    item47: convertDatasets(dataSet, 'position-b3-5', true),
    item48: convertDatasets(dataSet, 'name-b3-6', true),
    item49: convertDatasets(dataSet, 'position-b3-6', true),
    item50: convertDatasets(dataSet, 'title-b3-7', true),
    item51: convertDatasets(dataSet, 'name-b3-7', true),
    item52: convertDatasets(dataSet, 'position-b3-7', true),
    item53: convertDatasets(dataSet, 'header-block4', true),
    item54: convertDatasets(dataSet, 'icon-title-Expert', true),
    item55: convertDatasets(dataSet, 'icon-title-Experience', true),
    item56: convertDatasets(dataSet, 'name-b3-8', true),
    item57: convertDatasets(dataSet, 'position-b3-8', true),
    item58: convertDatasets(dataSet, 'image-b3-8', true),
    item59: convertDatasets(dataSet, 'name-b3-9', true),
    item60: convertDatasets(dataSet, 'position-b3-9', true),
    item61: convertDatasets(dataSet, 'image-b3-9', true),
    item62: convertDatasets(dataSet, 'new-title', true),
    item63: convertDatasets(dataSet, 'image-b3-10', true),
    item64: convertDatasets(dataSet, 'name-b3-10', true),
    item65: convertDatasets(dataSet, 'position-b3-10', true),
    item66: convertDatasets(dataSet, 'image-b3-11', true),
    item67: convertDatasets(dataSet, 'name-b3-11', true),
    item68: convertDatasets(dataSet, 'position-b3-11', true),
    item69: convertDatasets(dataSet, 'image-b3-12', true),
    item70: convertDatasets(dataSet, 'name-b3-12', true),
    item71: convertDatasets(dataSet, 'position-b3-12', true),
    item72: convertDatasets(dataSet, 'image-b3-13', true),
    item73: convertDatasets(dataSet, 'name-b3-13', true),
    item74: convertDatasets(dataSet, 'position-b3-13', true),
    item75: convertDatasets(dataSet, 'image-b3-14', true),
    item76: convertDatasets(dataSet, 'name-b3-14', true),
    item77: convertDatasets(dataSet, 'position-b3-14', true),
    item78: convertDatasets(dataSet, 'image-b3-15', true),
    item79: convertDatasets(dataSet, 'name-b3-15', true),
    item80: convertDatasets(dataSet, 'position-b3-15', true),
    item81: convertDatasets(dataSet, 'title-b3-16', true),
    item82: convertDatasets(dataSet, 'image-b3-16', true),
    item83: convertDatasets(dataSet, 'name-b3-16', true),
    item84: convertDatasets(dataSet, 'position-b3-16', true)
  };

  const refExpert = useRef<any>(null);
  const refExperience = useRef<any>(null);

  const handleScrollTo = (where: string) => {
    if (where === 'Expert') {
      refExpert.current?.scrollIntoView({ behavior: 'smooth' });
    } else if (where === 'Experience') {
      refExperience.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <SectionWrapper className='section-3'>
      <div className='block-1'>
        <div className='container'>
          <div className='header'>
            <span> AGENDA </span>
            {!isEmpty(allData.item1) && (
              <div className='image-header'>
                <img src={allData?.item1} title={'image-icon'} />
              </div>
            )}
          </div>
          <div className='content'>
            <h3>{allData.item16}</h3>
            <h3>{allData.item17}</h3>
            <div className='agenda'>
              <div className='timeline'>
                <div className='time'>{allData.item18}</div>
                <div className='desc'>{allData.item24}</div>
              </div>
              <div className='timeline'>
                <div className='time'>{allData.item19}</div>
                <div className='desc'> {allData.item25}</div>
              </div>
              <div className='timeline'>
                <div className='time'>{allData.item20}</div>
                <div className='desc'> {allData.item26}</div>
              </div>
              <div className='timeline'>
                <div className='time'>{allData.item21}</div>
                <div className='desc'> {allData.item27}</div>
              </div>
              <div className='timeline'>
                <div className='time'>{allData.item22}</div>
                <div className='desc'>{allData.item28}</div>
              </div>
              <div className='timeline'>
                <div className='time'>{allData.item23}</div>
                <div className='desc'>{allData.item29}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='block-2'>
        <div className='container'>
          <div className='header'>
            <span>SHALL WE SLEEP?</span>
            <p>{allData.item30}</p>
          </div>
          <div className='content'>
            <div className='card-item'>
              {!isEmpty(allData.item2) && (
                <div className='image' onClick={handleRefExclusive}>
                  <img src={allData?.item2} title={'image-icon'} />
                </div>
              )}
              <h3>Exclusive</h3>
              <span>{allData.item31}</span>
            </div>
            <div className='card-item'>
              {!isEmpty(allData.item3) && (
                <div className='image' onClick={() => handleScrollTo('Expert')}>
                  <img src={allData?.item3} title={'image-icon'} />
                </div>
              )}
              <h3>Expert</h3>
              <span>{allData.item32}</span>
            </div>
            <div className='card-item'>
              {!isEmpty(allData.item4) && (
                <div className='image' onClick={() => handleScrollTo('Experience')}>
                  <img src={allData?.item4} title={'image-icon'} />
                </div>
              )}
              <h3>Experience</h3>
              <span>{allData.item33}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='block-3' ref={refExpert}>
        <div className='container'>
          <div className='header'>
            {!isEmpty(allData.item3) && (
              <div className='image'>
                <img src={allData?.item54} title={'image'} />
              </div>
            )}
            <span>EXPERT</span>
          </div>
          <div className='text-title'>
            <span>{allData.item34}</span>
          </div>
          <div className='content'>
            <div className='card'>
              <span className='title'>{allData.item35}</span>
              {!isEmpty(allData.item5) && (
                <div className='image'>
                  <img src={allData?.item5} title={'image'} />
                </div>
              )}
              <span className='name'>{allData.item36}</span>
              <span className='sub'>{allData.item37}</span>
            </div>
            {/* <div className='card'>
              <span className='title'>{allData.item38}</span>
              {!isEmpty(allData.item6) && (
                <div className='image'>
                  <img src={allData?.item6} title={'image'} />
                </div>
              )}
              <span className='name'>{allData.item39}</span>
              <span className='sub'>{allData.item40}</span>
            </div> */}
          </div>
          <div className='text-title'>
            <span>{allData.item41}</span>
          </div>
          <div className='content flex-4'>
            {!isEmpty(allData.item7) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item7} title={'image'} />
                </div>
                <span className='name'>{allData.item42}</span>
                <span className='sub'>{allData.item43}</span>
              </div>
            )}
            {!isEmpty(allData.item8) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item8} title={'image'} />
                </div>
                <span className='name'>{allData.item44}</span>
                <span className='sub'>{allData.item45}</span>
              </div>
            )}
            {!isEmpty(allData.item9) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item9} title={'image'} />
                </div>
                <span className='name'>{allData.item46}</span>
                <span className='sub'>{allData.item47}</span>
              </div>
            )}
            {!isEmpty(allData.item10) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item10} title={'image'} />
                </div>
                <span className='name'>{allData.item48}</span>
                <span className='sub'>{allData.item49}</span>
              </div>
            )}
            {!isEmpty(allData.item58) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item58} title={'image'} />
                </div>
                <span className='name'>{allData.item56}</span>
                <span className='sub'>{allData.item57}</span>
              </div>
            )}
            {/* <div className='card'>
              {!isEmpty(allData.item61) && (
                <div className='image'>
                  <img src={allData?.item61} title={'image'} />
                </div>
              )}
              <span className='name'>{allData.item59}</span>
              <span className='sub'>{allData.item60}</span>
            </div> */}
          </div>
          <div className='content last-item'>
            {!isEmpty(allData.item11) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item11} title={'image'} />
                </div>
                <span className='title'>{allData.item50}</span>
                <span className='name'>{allData.item51}</span>
                <span className='sub'>{allData.item52}</span>
              </div>
            )}
          </div>
          <div className='text-title'>
            <span>{allData.item62}</span>
          </div>
          <div className='content flex-4'>
            {!isEmpty(allData.item63) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item63} title={'image'} />
                </div>
                <span className='name'>{allData.item64}</span>
                <span className='sub'>{allData.item65}</span>
              </div>
            )}
            {!isEmpty(allData.item66) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item66} title={'image'} />
                </div>
                <span className='name'>{allData.item67}</span>
                <span className='sub'>{allData.item68}</span>
              </div>
            )}
            {!isEmpty(allData.item69) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item69} title={'image'} />
                </div>
                <span className='name'>{allData.item70}</span>
                <span className='sub'>{allData.item71}</span>
              </div>
            )}
            {!isEmpty(allData.item72) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item72} title={'image'} />
                </div>
                <span className='name'>{allData.item73}</span>
                <span className='sub'>{allData.item74}</span>
              </div>
            )}
            {!isEmpty(allData.item75) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item75} title={'image'} />
                </div>
                <span className='name'>{allData.item76}</span>
                <span className='sub'>{allData.item77}</span>
              </div>
            )}
            {!isEmpty(allData.item78) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item78} title={'image'} />
                </div>
                <span className='name'>{allData.item79}</span>
                <span className='sub'>{allData.item80}</span>
              </div>
            )}
          </div>
          <div className='content last-item'>
            {!isEmpty(allData.item82) && (
              <div className='card'>
                <div className='image'>
                  <img src={allData?.item82} title={'image'} />
                </div>
                <span className='title'>{allData.item81}</span>
                <span className='name'>{allData.item83}</span>
                <span className='sub'>{allData.item84}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='block-4' ref={refExperience}>
        <div className='container'>
          <div className='header'>
            {!isEmpty(allData.item4) && (
              <div className='image'>
                <img src={allData?.item55} title={'image'} />
                <span>EXPERIENCE</span>
              </div>
            )}
            <text>{allData.item53}</text>
          </div>
          <div className='img-list'>
            {!isEmpty(allData.item12) && (
              <div className='image'>
                <img src={allData?.item12} title={'image'} />
              </div>
            )}
            {!isEmpty(allData.item13) && (
              <div className='image'>
                <img src={allData?.item13} title={'image'} />
              </div>
            )}
            {!isEmpty(allData.item14) && (
              <div className='image'>
                <img src={allData?.item14} title={'image'} />
              </div>
            )}
            {!isEmpty(allData.item15) && (
              <div className='image'>
                <img src={allData?.item15} title={'image'} />
              </div>
            )}
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  .block-1 {
    background-color: #d7929d;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      span {
        color: #fff;
        font-size: 36px;
        font-weight: 900;
        @media (max-width: 768px) {
          font-size: 28px;
        }
      }
      .image-header {
        width: 100px;
        img {
          width: 100%;
        }
      }
    }
    .content {
      text-align: center;
      color: #fff;
      h3 {
        font-size: 24px;
        font-weight: 800;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
      .agenda {
        padding: 40px 0 80px 0;
        .timeline {
          font-size: 24px;
          display: flex;
          justify-content: center;
          font-weight: 300;
          margin-top: 12px;
          @media (max-width: 768px) {
            font-size: 16px;
          }
          .time {
            text-align: start;
            width: 20%;
            @media (max-width: 768px) {
              width: 40%;
            }
          }
          .desc {
            text-align: start;
            width: 70%;
          }
        }
      }
    }
  }
  .block-2 {
    background-color: #6b64a0;
    .header {
      display: flex;
      justify-content: center;
      padding: 40px 40px 20px 0px;
      @media (max-width: 768px) {
        flex-direction: column;
        padding-right: 0;
      }
      span {
        line-height: 1.6;
        width: 35%;
        color: #fff;
        font-size: 40px;
        font-weight: 800;
        @media (max-width: 768px) {
          font-size: 28px;
          width: 100%;
        }
      }
      p {
        line-height: 1.6;
        width: 55%;
        color: #fff;
        font-size: 24px;
        font-weight: 300;
        @media (max-width: 768px) {
          margin: 0;
          margin-bottom: 20px;
          width: 100%;
          font-size: 18px;
        }
        @media (max-width: 500px) {
          font-size: 15px;
        }
      }
    }
    .card-item {
      width: 33.33%;
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 20px;
      @media (max-width: 690px) {
        width: 100%;
        gap: 10px;
      }
      .image {
        width: 20%;
        margin: auto;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
      h3 {
        color: #fff;
        font-size: 32px;
        font-weight: 800;
        @media (max-width: 768px) {
          font-size: 24px;
        }
      }
      span {
        padding: 0 20px;
        color: #fff;
        font-size: 22px;
        font-weight: 200;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }
    }
    .content {
      padding: 60px 0;
      display: flex;
      align-items: flex-start;
      gap: 40px;
      @media (max-width: 690px) {
        flex-direction: column;
        padding: 20px 0 50px 0;
      }
    }
  }
  .block-3 {
    background-color: #d7929d;
    .header {
      display: flex;
      align-items: center;
      padding: 40px 0px;
      gap: 20px;
      .image {
        width: 65px;
        img {
          width: 65px;
        }
      }
      span {
        line-height: 1.6;
        width: 35%;
        color: #fff;
        font-size: 44px;
        font-weight: 800;
        @media (max-width: 768px) {
          font-size: 28px;
          width: 100%;
        }
      }
    }
    .text-title {
      color: #fff;
      font-size: 28px;
      font-weight: 800;
      width: 700px;
      @media (max-width: 768px) {
        width: unset;
        font-size: 20px;
      }
    }
    .content {
      display: flex;
      padding: 40px 0 40px 0;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
      /* @media (max-width: 690px) {
        flex-direction: column;
      } */
      .card {
        width: 40%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media (max-width: 690px) {
          width: 100%;
        }
        .title {
          color: #fff;
          font-size: 24px;
          font-weight: 700;
          width: 75%;
          @media (max-width: 768px) {
            width: unset;
            font-size: 20px;
          }
        }
        .image {
          width: 180px;
          padding: 20px 0;
          @media (max-width: 400px) {
            width: 140px;
          }
          img {
            border-radius: 50%;
            object-fit: cover;
            width: 100%;
            height: 180px;
            @media (max-width: 400px) {
              height: 140px;
            }
          }
        }
        .name {
          color: #fff;
          font-size: 20px;
          font-weight: 500;
          @media (max-width: 768px) {
            width: unset;
            font-size: 18px;
          }
        }
        .sub {
          color: #fff;
          font-size: 16px;
          font-weight: 300;
          max-width: 350px;
          @media (max-width: 768px) {
            max-width: unset;
            width: unset;
            font-size: 16px;
          }
        }
      }
    }
    .flex-4 {
      flex-wrap: wrap !important;
      padding: 40px 0 10px 0 !important;
      .sub {
        margin-top: 8px !important;
      }
      .name {
        min-height: 61px !important;
        font-weight: 900 !important;
      }
      .card {
        width: 16% !important;
        @media (max-width: 1111px) {
          width: 48% !important;
        }
        /* @media (max-width: 690px) {
          width: 100% !important;
        } */
      }
    }
    .last-item {
      padding: 0 !important;
      padding-bottom: 48px !important;
      .title {
        font-weight: 300 !important;
      }
      .name {
        font-weight: 900 !important;
      }
      .sub {
        margin-top: 16px !important;
      }
    }
  }
  .block-4 {
    background-color: #6b64a0;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 60px 0px;
      @media (max-width: 768px) {
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 20px;
      }
      .image {
        display: flex;
        align-items: center;
        gap: 20px;
        width: 65px;
        img {
          width: 65px;
        }
      }
      span {
        line-height: 1.6;
        width: 35%;
        color: #fff;
        font-size: 44px;
        font-weight: 800;
        @media (max-width: 768px) {
          font-size: 28px;
          width: 100%;
        }
      }
      text {
        width: 62%;
        line-height: 1.6;
        color: #fff;
        font-size: 24px;
        font-weight: 400;
        @media (max-width: 768px) {
          font-size: 20px;
          width: 100%;
        }
      }
    }
    .img-list {
      display: flex;
      overflow: hidden;
      flex-wrap: wrap;
      .image {
        width: 25%;
        display: flex;
        @media (max-width: 767px) {
          width: 50% !important;
        }
        img {
          width: 100%;
          object-fit: cover;
          height: 500px;
          @media (max-width: 767px) {
            height: 250px;
          }
        }
      }
    }
  }
`;
export default SectionThree;
